import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { GetCardList } from '../../../Redux/AdminPanel/PurchaseCreditSlice'
import { startLoadding, stopLoading } from '../../../Redux/FrontEnd/Loading/LoadingSlice'
import { fetchAsyncUserDetails } from '../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import PaymentSuccessPopup from '../../../Components/PaymentSuccessPopup'
import { ENV } from '../../../Utils/_helpers/EnvHelper'
import { getUserData } from '../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'

const CARD_OPTIONS: any = {
  iconStyle: 'solid',
  hidePostalCode: true,

  style: {
    base: {
      color: '#303238',
      fontSize: '16px',
      fontFamily: 'sans-serif',
      fontSmoothing: 'antialiased',
      '::placeholder': {
        color: '#CFD7DF',
      },
    },
    invalid: {
      color: '#e5424d',
      ':focus': {
        color: '#303238',
      },
    },
  },
}
const CardAddPopup = ({
  show,
  handleClose,
  total,
  customData,
  couponId,
  restData,
  popupOpen = true,
}: any) => {
  const dispatch = useDispatch()
  const userData = useSelector(getUserData)
  const [name, setName] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(true)
  const [complete, setComplete] = useState(false)
  const [cardID, setCardID] = useState<any>('')
  const [successPopup, setsuccessPopup] = useState(false)
  const stripe: any = useStripe()
  const elements: any = useElements()
  const API_URL = ENV().REACT_APP_API_URL

  const cards = useSelector((state: any) => state?.productList?.cardList)


  const dispatchSuccessCreate = () => {
    dispatch(fetchAsyncUserDetails({ with: 'stripeDefaultSource' })).then(((result: any) => {
      const stripeDefaultSource = result?.payload?.data?.user?.stripeDefaultSource
      if (stripeDefaultSource) {
        setCardID(stripeDefaultSource)
      } else {
        setCardID('')
      }
      dispatch(stopLoading())
      setsuccessPopup(true)
      setSuccess(true)
      handleClose()
      dispatch(GetCardList()).then((res: any) => {
        if (!res?.payload?.data.length) {
          setCardID('')
        }
      })
    }))
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    try {
      dispatch(startLoadding())

      if (cardID) {
        const reqBody = {
          credit: customData,
          card: cardID,
        }

        axios
          .post(`${API_URL}user/createCard`, reqBody, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          })
          .then((res: any) => {
            if (res?.status == 200) {
              dispatchSuccessCreate()
            }
          })
          .catch((err: any) => {
            dispatch(stopLoading())
            handleClose()
            toast.error('Create Card fail')
            setCardID('')
          })
      } else {
        if (elements == null) {
          return
        }

        const cardElement = elements.getElement('card')

        const token = await stripe.createToken(cardElement, { name })
        const { error, paymentMethod } = await stripe.createPaymentMethod({
          type: 'card',
          card: elements.getElement(CardElement),
          billing_details: {
            name,
          },
        })


        if (!error) {
          const reqBody = {
            credit: customData,
            token: token?.token?.id,
            paymentMethodId: paymentMethod?.id
          }

          axios
            .post(`${API_URL}user/createCard`, reqBody, {
              headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            })
            .then((res: any) => {
              if (res?.status == 200) {
                dispatchSuccessCreate()
              }
            })
            .catch((err: any) => {
              dispatch(stopLoading())
              handleClose()
              toast.error('Create card fail')
            })
        } else {
          toast.error(error?.message ?? 'Create card fail')
          dispatch(stopLoading())
        }
      }
    } catch (error) {

      toast.error('Stripe Failed to load!')
      dispatch(stopLoading())
    }
  }

  const handleDelete = async (e: any) => {
    e.preventDefault()
    try {
      dispatch(startLoadding())

      if (cardID) {
        const reqBody = {
          card: cardID,
        }

        axios
          .post(`${API_URL}user/deleteCard`, reqBody, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          })
          .then((res: any) => {
            if (res?.status == 200) {
              dispatchSuccessCreate()
            }
          })
          .catch((err: any) => {
            dispatch(stopLoading())
            handleClose()
            toast.error('Delete Credit Card Failed')
            setCardID('')
          })
      }
    } catch (error) {
      toast.error('Stripe Failed to load!')
      dispatch(stopLoading())
    }
  }
  useEffect(() => {
    dispatch(GetCardList()).then((res: any) => {
      if (res?.payload?.data?.length > 0) {
        dispatch(fetchAsyncUserDetails({ with: 'stripeDefaultSource' })).then(((result: any) => {
          const stripeDefaultSource = result?.payload?.data?.user?.stripeDefaultSource
          if (stripeDefaultSource) {
            setCardID(stripeDefaultSource)
          } else {
            setCardID('')
          }
        }))
      }
    })
  }, [])
  return (
    <>
      <Modal backdrop='static' className='payment_modal' show={show} onHide={handleClose}>
        <div className='modal-header text-center row'>
          <h1>Cards</h1>
        </div>
        <div className='modal-body'>
          {cards?.length > 0 && (

            <div className='row m-0 mt-5 mb-10 card_box'>
              {cards?.map((val: any, index: any) => (
                <div
                  key={index}
                  className='form-check form-check-custom form-check-solid p-5 col-12 credit-card visa selectable '
                >

                  <input
                    className='form-check-input'
                    type='radio'
                    // value={key.value}
                    id='flexRadioChecked'
                    name='role'
                    checked={val?.id == cardID}
                    onChange={() => {
                      setSuccess(true)
                      val?.id == cardID ? setCardID('') : setCardID(val?.id)
                      setComplete(true)
                    }}
                  />
                  <label className='form-check-label' htmlFor='kt_modal_update_role_option_0'>
                    <div className='text-black-600 visa'>
                      <span className='badge badge-light-success'>{val?.brand}</span>{' '}
                      <span>
                        Expires {val?.exp_month}/{val?.exp_year}{' '}
                      </span>
                    </div>
                    <div className='fw-bolder card-label fs-4 mb-2'>XXXXXXX{val?.last4}</div>
                    <span className='fw-bolder fs-4 mb-1 credit-cardholder'>{val?.name}</span>
                  </label>
                </div>
              ))}
            </div>
          )}
          {cards?.length !== 0 && (
            <button
              onClick={() => {
                setSuccess(false)
                setCardID('')
                setComplete(false)
              }}
              className='btn-sm btn-primary'
            >
              Add New Card
            </button>
          )}

          {(!success || cards?.length == 0) && (
            <fieldset className='FormGroup mt-10 border-0 p-0'>
              <div className='FormRow'>
                {/* <label className='fw-bolder text-dark fs-3'>Name</label> */}
                <input
                  onChange={(e: any) => {
                    let val = e.target.value

                    setName(val)
                      ; /^(?:[A-Za-z]+ ?){1,3}$/.test(val)
                        ? setError('')
                        : setError('Please enter valid Name')
                  }}
                  // onBlur={() => {}}
                  className='form-control form-control-lg form-control-solid w-100 my-3'
                  type='text'
                  placeholder='Card holder name'
                />
                <span className='text-danger'>{error}</span>
                <CardElement
                  onChange={(e) => {
                    setComplete(e?.complete)
                  }}
                  options={CARD_OPTIONS}
                />
              </div>
            </fieldset>
          )}
        </div>
        <div className='modal-footer border-top w-100'>
          {cards?.length > 0 &&
            <Button
              color='danger'
              disabled={!cardID}
              onClick={handleDelete}
              className='btn-danger'
            >
              <span className='px-1'>Remove</span>
            </Button>
          }
          <Button
            color='secondary'
            onClick={() => {
              handleClose()
            }}
            className='btn-light-primary'
          >
            Cancel
          </Button>
          <Button
            color='danger'
            disabled={!cardID ? !(complete && name !== '') : !cardID}
            onClick={handleSubmit}
          >
            <span className='px-8'>Add</span>
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default CardAddPopup
